<template>
  <div class="classic-record">
    <CategoryContents :categoryId="categoryId" />
  </div>
</template>

<script>
import CategoryContents from "@/components/Category/CategoryContents.vue";

export default {
  name: "ClassicRecord",
  components: {
    CategoryContents,
  },
  props: {
    categoryId: String
  },
  data() {
    return {
      // 
    };
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
